import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import download from "downloadjs";
import {USER_LOCALSTORAGE_KEY} from "shared/const/localstorage";
import {createRequestParams} from "common/hook/create-request-params/createRequestParams";
interface ISummaryTableExcel {
    from?: string;
    to?: string;
}


export const getSummaryTableExcel = createAsyncThunk(
    "summaryTable/getSummaryTableExcel",
    async ({ from, to }: ISummaryTableExcel, thunkAPI) => {

        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }

            const { token } = JSON.parse(authToken);

            const params = createRequestParams(from, to);

            const response = await axios.get(`/api/pivot-table/report`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                responseType: "blob",
                params,
            });

            if (!response.data) {
                throw new Error("Response data is empty");
            }

            // Use downloadjs to trigger the file download
            download(response.data, "file.xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");

            return response.data;
        } catch (error) {
            // Handle the error
            // @ts-ignore
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);


